module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/favicon-16x16-80654150f62eeed096ff27c54cf0028b.png";